<template>
	<v-text-field
		ref="priceField"
		v-model="price"
		v-bind="$attrs"
		:rules="[v => !!v || $gettext(fieldName + ' is required'),
			validatePrice || $gettext(fieldName + ' is invalid')]"
		placeholder="20,43"
		prefix="€"
		variant="outlined"
		@keypress="onlyForCurrency"
	>
		<template
			v-if="showCheckmark && validatePrice(price)"
			#append-inner
		>
			<v-icon
				color="primary"
				icon="$check"
			/>
		</template>
	</v-text-field>
</template>

<script>

export default {
	name: 'PriceField',
	props: {
		modelValue: {
			type: String,
			default: '',
		},
		fieldName: {
			type: String,
			default: 'Phone Purchase Price'
		},
		showCheckmark: {
			type: Boolean,
			required: false,
			default: false
		},
		allowNegative: {
			type: Boolean,
			default: false,
		}
	},

	emits: ['update:modelValue',],

	data () {
		return {
			price: '',
		};
	},

	computed: {
		/**
		 * Users have preference of seeing a comma over a dot. But overall back-end representation is a dot
		 *
		 * @returns {string}
		 */
		dotPrice: function () {
			return this.price.replace(',', '.');
		},
	},
	watch: {
		price () {
			this.$emit('update:modelValue', this.dotPrice);
		},
		modelValue () {
			this.price = this.modelValue ? this.modelValue.replace('.', ',') : '';
		},
	},

	mounted () {
		this.price = this.modelValue ? this.modelValue.replace('.', ',') : '';
	},
	methods: {

		/**
		 *
		 * @param {string} v
		 * @returns {boolean}
		 */
		validatePrice (v) {
			return ((!!v && (v.indexOf(',') > -1 && v.split(',')[1].length <= 2 || v.indexOf(',') <= -1)) && (v.indexOf('-') === 0 || v.indexOf('-') === -1));
		},

		/**
		 * @param {object} $event
		 */
		onlyForCurrency ($event) {
			const keyCode = ($event.keyCode ? $event.keyCode : $event.which);

			// only allow number and one dot
			if ((keyCode < 48 || keyCode > 57) && (keyCode !== 44 || this.price.indexOf(',') !== -1) && (keyCode !== 46 || this.price.indexOf(',') !== -1) && (keyCode !== 45 || !this.allowNegative || this.price.indexOf('-') !== -1)) { // 44 is comma
				$event.preventDefault();
			}
		},

		/**
		 * Valid to be used by parent components
		 *
		 * @returns {boolean} whether value is valid
		 */
		valid () {
			return this.$refs.priceField.valid;
		}
	}
};
</script>

<style scoped>

</style>
